import { KENYA_CALLING_CODE, withoutKenyaCallingCode } from '@chukua/common';
import { Input, type InputProps } from 'antd';

type KenyanMobileInputProps = Omit<InputProps, 'value' | 'prefix' | 'inputMode' | 'placeholder'> & { value?: string | null };

/**
 * A Kenyan mobile number with +254 shown beside it, so people type the number as they would say it (0712 345 678 or
 * 712345678). The form keeps what was typed; `toKenyanMobile` turns it into E.164 when the form is sent. A stored number
 * shows without its +254.
 */
export function KenyanMobileInput({ value, ...props }: KenyanMobileInputProps) {
  return (
    <Input
      {...props}
      value={value ? withoutKenyaCallingCode(value) : undefined}
      prefix={<span className="text-muted">{KENYA_CALLING_CODE}</span>}
      inputMode="tel"
      autoComplete="tel-national"
      placeholder="712 345 678"
    />
  );
}
